import { createGlobalStyle } from 'styled-components';

import MultiBoldWoff from '@/assets/fonts/Multi_015-Bold.woff';
import MultiBoldWoff2 from '@/assets/fonts/Multi_015-Bold.woff2';
import MultiRegularWoff from '@/assets/fonts/Multi_015-Regular.woff';
import MultiRegularWoff2 from '@/assets/fonts/Multi_015-Regular.woff2';
import MultiSemiBoldWoff from '@/assets/fonts/Multi_015-SemiBold.woff';
import MultiSemiBoldWoff2 from '@/assets/fonts/Multi_015-SemiBold.woff2';

export const GlobalStyle = createGlobalStyle`
   @font-face {
    font-family: 'Multi';
    src: url(${MultiBoldWoff2}) format('woff2'),
         url(${MultiBoldWoff}) format('woff');
    font-weight: 700;
    font-style: normal;
    font-display: swap;
  }

  @font-face {
    font-family: 'Multi';
    src: url(${MultiSemiBoldWoff2}) format('woff2'),
         url(${MultiSemiBoldWoff}) format('woff');
    font-weight: 600;
    font-style: normal;
    font-display: swap;
  }

  @font-face {
    font-family: 'Multi';
    src: url(${MultiRegularWoff2}) format('woff2'),
         url(${MultiRegularWoff}) format('woff');
    font-weight: 400;
    font-style: normal;
    font-display: swap;
  }
`;
export default GlobalStyle;
